import cross from '@assets/nuevos-iconos/x.png'
import { copyProyect } from '@proxies/copyProyect'
import * as Dialog from '@radix-ui/react-dialog'
import * as Form from '@radix-ui/react-form'
import { useAppStore } from '@store'
import { ChangeEvent, FormEvent, useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { emptyClientInfo } from '../../store/baseValues'

export function DuplicateProject() {
  const openModal = useAppStore.use.openModal()
  const closeModal = useAppStore.use.closeModal()
  const impuestos = useAppStore.use.impuestos()
  const { idVersiones } = useParams()
  const navigate = useNavigate()
  const hRef = '/planner/proyectos'
  const formfield = 'mt-1 flex justify-between'
  const location = useLocation()
  const imagenes = location.state?.imagenes
  const imagen2D = imagenes.find((imagen) => imagen.nombre === '2D')

  const [clientInfo, setClientInfo] = useState(emptyClientInfo)
  const [errorMessage, setErrorMessage] = useState<string | null>(null)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const date = new Date().toISOString()

  useEffect(() => {
    openModal()
    return () => closeModal()
  }, [openModal, closeModal])

  function handleInput(event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
    const { name, value } = event.target
    setClientInfo((prevState) => ({
      ...prevState,
      [name]: value,
    }))
  }

  async function handleClick() {
    setIsSubmitting(true)
    setErrorMessage(null)

    try {
      const response = await copyProyect(Number(idVersiones), clientInfo, date)

      console.log('Proyecto duplicado exitosamente:', response)
      closeModal()
      navigate('/planner/duplicated')
    } catch (error: any) {
      setErrorMessage(error.message || 'Ocurrió un error inesperado.')
    } finally {
      setIsSubmitting(false)
    }
  }

  function handleChange(e: FormEvent<HTMLFormElement>) {
    setClientInfo((prev) => ({ ...prev, idImpuestos: Number(e.target.value) }))
  }

  const currentDate = new Date().toLocaleDateString()

  return (
    <div className='white-background h-100vh w-100vw scrollbar absolute bottom-0 left-0 right-0 top-0 m-auto flex flex-col items-center overflow-x-hidden overflow-y-scroll rounded-[15px]'>
      <Dialog.Root open={true}>
        <Dialog.Content
          onInteractOutside={(e) => {
            e.preventDefault()
            e.stopPropagation()
          }}
          className=' absolute inset-0 left-1/2 top-1/2 h-[555px] w-[1080px] -translate-x-1/2 -translate-y-1/2 place-items-center justify-center rounded-[15px] border-2 border-solid border-C/Color3 bg-C/Color1 shadow-xl'
        >
          <Form.Root>
            <div className='savetitulo ml-3 mt-8 flex h-[500px] w-[440px] flex-col space-y-3 rounded-md border-none bg-C/Color10 p-3 shadow-md'>
              <h5 className='ml-1 mt-1 border-b-2 border-C/Color3 text-lg font-normal text-C/Color5'>
                {'Guardar proyecto'}
              </h5>
              {/* Mostrar errores */}
              {errorMessage && (
                <div className='absolute left-[11.5rem] top-[4.5rem] text-[10px] text-C/Color6'>
                  {errorMessage}
                </div>
              )}
              <Dialog.Close asChild>
                <img
                  onClick={() => {
                    closeModal()
                    navigate(-1)
                  }}
                  className='absolute right-2.5 top-0.5 cursor-pointer'
                  src={cross}
                  alt='Close Modal'
                />
              </Dialog.Close>
              <Form.Field
                name='proyectname'
                className={formfield}
              >
                <Form.Label className='mt-3 text-lg text-C/Color5'>{'Nombre proyecto'}</Form.Label>
                <Form.Control asChild>
                  <input
                    onChange={(e) => handleInput(e)}
                    type='text'
                    name='nombreProyecto'
                    id='proyectName'
                    value={clientInfo.nombreProyecto}
                    className='proyectName ml-2 mt-3 w-[260px] rounded-sm border border-solid border-C/Color4 pl-1 text-lg text-C/Color4'
                  />
                </Form.Control>
              </Form.Field>
              {imagen2D && (
                <div
                  className='relative mb-4 ml-8 mt-4'
                  style={{ height: '280px', width: '350px' }}
                >
                  <img
                    key={imagen2D.nombre}
                    className='absolute left-0 top-0 z-20 h-full w-full object-cover'
                    src={imagen2D.imageUrl}
                    alt={imagen2D.nombre}
                  />
                </div>
              )}
              <Form.Field
                name='description'
                className={formfield}
              >
                <Form.Label className='mt-1 text-lg text-C/Color5'>{'Descripción'}</Form.Label>
                <Form.Control asChild>
                  <textarea
                    onChange={(e) => handleInput(e)}
                    name='descripcion'
                    id='proyectDescription'
                    value={clientInfo.descripcion}
                    className='text-md mt-1 h-[80px] w-[300px] rounded-sm border border-solid border-C/Color4 pl-1 text-lg text-C/Color5'
                  />
                </Form.Control>
              </Form.Field>
            </div>

            <div className='-mt-[505px] ml-[450px] flex flex-col'>
              <div className='mb-1 ml-3 mt-1 h-[255px] w-[600px] grid-cols-2 grid-rows-4 gap-3 rounded-md border-none bg-C/Color10 p-4 shadow-md'>
                <h5 className=' w-[265px] border-b-2 border-solid border-C/Color3 text-lg font-normal text-C/Color5'>
                  {'Datos del cliente'}
                </h5>
                <div className='proyectSecondaryGrid -mr-1 mt-4 grid grid-cols-2 gap-3 gap-x-10 text-left text-lg text-main-gray'>
                  <Form.Field
                    name='username'
                    className={formfield}
                  >
                    <Form.Label className='FormLabel mr-2 text-C/Color5'>{'Nombre'}</Form.Label>
                    <Form.Control asChild>
                      <input
                        className='ml-1 h-[28px] w-[180px] rounded-sm border border-solid border-C/Color4 pl-1 text-C/Color4'
                        onChange={(e) => handleInput(e)}
                        type='text'
                        name='nombre'
                        id='userName'
                        value={clientInfo.nombre}
                      />
                    </Form.Control>
                  </Form.Field>
                  <Form.Field
                    name='usersurname'
                    className={formfield}
                  >
                    <Form.Label className='FormLabel mr-2 text-C/Color5'>{'Apellidos'}</Form.Label>
                    <Form.Control asChild>
                      <input
                        className='ml-1 h-[28px] w-[180px] rounded-sm border border-solid border-C/Color4 pl-1 text-C/Color4'
                        onChange={(e) => handleInput(e)}
                        type='text'
                        name='apellidos'
                        id='userSurname'
                        value={clientInfo.apellidos}
                      />
                    </Form.Control>
                  </Form.Field>
                  <Form.Field
                    name='address'
                    className={formfield}
                  >
                    <Form.Label className='FormLabel mr-2 text-C/Color5'>{'Dirección'}</Form.Label>
                    <Form.Control asChild>
                      <input
                        className='ml-1 h-[28px] w-[180px] rounded-sm border border-solid border-C/Color4 pl-1 text-C/Color4'
                        onChange={(e) => handleInput(e)}
                        type='text'
                        name='direccion'
                        id='userAddress'
                        value={clientInfo.direccion}
                      />
                    </Form.Control>
                  </Form.Field>
                  <Form.Field
                    name='city'
                    className={formfield}
                  >
                    <Form.Label className='FormLabel mr-2 text-C/Color5'>{'Ciudad'}</Form.Label>
                    <Form.Control asChild>
                      <input
                        className='ml-1 h-[28px] w-[180px] rounded-sm border border-solid border-C/Color4 pl-1 text-C/Color4'
                        onChange={(e) => handleInput(e)}
                        type='text'
                        name='poblacion'
                        id='userCity'
                        value={clientInfo.poblacion}
                      />
                    </Form.Control>
                  </Form.Field>
                  <Form.Field
                    name='postcode'
                    className={formfield}
                  >
                    <Form.Label className='FormLabel mr-2 text-C/Color5'>{'C.P.'}</Form.Label>
                    <Form.Control asChild>
                      <input
                        className='ml-1 h-[28px] w-[180px] rounded-sm border border-solid border-C/Color4 pl-1 text-C/Color4'
                        onChange={(e) => handleInput(e)}
                        type='text'
                        name='codPostal'
                        id='userPostcode'
                        value={clientInfo.codPostal}
                      />
                    </Form.Control>
                  </Form.Field>
                  <Form.Field
                    name='country'
                    className={formfield}
                  >
                    <Form.Label className='FormLabel mr-2 text-C/Color5'>{'Pais'}</Form.Label>
                    <Form.Control asChild>
                      <input
                        className='ml-1 h-[28px] w-[180px] rounded-sm border border-solid border-C/Color4 pl-1 text-C/Color4'
                        onChange={(e) => handleInput(e)}
                        type='text'
                        name='pais'
                        id='userCountry'
                        value={clientInfo.pais}
                      />
                    </Form.Control>
                  </Form.Field>
                  <Form.Field
                    name='email'
                    className={formfield}
                  >
                    <Form.Label className='FormLabel mr-2 text-C/Color5'>{'Email'}</Form.Label>
                    <Form.Control asChild>
                      <input
                        className='ml-1 h-[28px] w-[180px] rounded-sm border border-solid border-C/Color4 pl-1 text-C/Color4'
                        onChange={(e) => handleInput(e)}
                        type='email'
                        name='email'
                        id='userEmail'
                        value={clientInfo.email}
                      />
                    </Form.Control>
                  </Form.Field>
                  <Form.Field
                    name='number'
                    className={formfield}
                  >
                    <Form.Label className='FormLabel mr-2 text-C/Color5'>{'Móvil'}</Form.Label>
                    <Form.Control asChild>
                      <input
                        className='ml-1 h-[28px] w-[180px] rounded-sm border border-solid border-C/Color4 pl-1 text-C/Color5'
                        onChange={(e) => handleInput(e)}
                        type='number'
                        name='movil'
                        id='userPhone'
                        value={clientInfo.movil}
                      />
                    </Form.Control>
                  </Form.Field>
                </div>
              </div>
              <div className='ml-3 mt-2 h-[235px] w-[600px]  rounded-md border-none bg-C/Color10 p-4 shadow-md'>
                <p className='mt-2 text-lg text-C/Color5'>
                  {'Fecha de inicio'}: {currentDate}
                </p>
                <Form.Field
                  name='impuestos'
                  className='formfield mt-4 text-lg text-C/Color5'
                  onChange={handleChange}
                >
                  <Form.Label className='relative mr-2 text-C/Color5'>{'Impuestos'}</Form.Label>
                  <select
                    className='bg-C/Color10'
                    value={clientInfo.idImpuestos}
                    onChange={handleChange}
                  >
                    {impuestos?.map((el) => (
                      <option
                        key={el.idImpuestos}
                        value={el.idImpuestos}
                      >
                        {el.nombreImpuesto}
                      </option>
                    ))}
                  </select>
                </Form.Field>
                <Dialog.Close asChild>
                  <button
                    className='absolute ml-[340px] mt-20 h-10 w-56 rounded-md border-2 border-C/Color7 bg-C/Color3 text-xl text-C/Color1'
                    type='submit'
                    onClick={handleClick}
                    disabled={isSubmitting}
                  >
                    {'Guardar'}
                  </button>
                </Dialog.Close>
              </div>
            </div>
          </Form.Root>
        </Dialog.Content>
      </Dialog.Root>
    </div>
  )
}
